import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import kouLogo from "../images/koulogo.png";
import adminHomeImg from "../images/adminhome.svg";
import AddUnitModal from "../components/AddUnitModal";
import api from "../services/api";
import "./pagesStyles/AdminHomePage.css";
import EmployeeDetailCard from "../components/EmployeeDetailCard"; // NEW
import UnitMonthlyTable from "../components/UnitMonthlyTable";     // NEW
import PartTimeEmployeeSearchResults from "../components/PartTimeEmployeeSearchResults"; // NEW


function AdminHomePage() {

  const [searchQuery, setSearchQuery] = useState("");


  const [puMonthlyEditing, setPuMonthlyEditing] = useState(false);
const [puMonthlyDraft, setPuMonthlyDraft] = useState(null);

  const [activeTab, setActiveTab] = useState("birimler");
  const [selectedUnit, setSelectedUnit] = useState(null);

      // Puantaj detail state
  const [puSelectedUnit, setPuSelectedUnit] = useState(null);
  const [puSelectedUnitName, setPuSelectedUnitName] = useState("");


  const [selectedUnitData, setSelectedUnitData] = useState(null); // NEW
  const [selectedUnitLoading, setSelectedUnitLoading] = useState(false); // NEW
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [institutions, setInstitutions] = useState([]);

  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedInstitution, setExpandedInstitution] = useState(null);
  const [announcement, setAnnouncement] = useState({
    title: "KISMI Zamanlı Çalışacak Öğrencilerin Alım İlanı",
    content: `Üniversitemiz 11/09/2024 tarihli ve 2024/9 nolu toplantısında alınan 97
sıra sayılı Yönetim Kurulu Kararına istinaden aylık KZÖ çalışma 30 saat ile
sınırlandırılmıştır.

Çalışma saati brüt ücreti, 2025 yılı brüt saatlik asgari ücret karşılığı kısmi zamanlı çalışacak öğrenci kontenjanları, çalıştırılacak yer ve işin niteliği birimler itibarıyle belirlenmiş olup aşağıdaki listede belirtilmiştir.

Öğrencilerin çalışma süresi haftada en fazla 15 saat olup, 01.09.2009 tarihinden itibaren Yüksek Öğretim Kurulu tarafından yürürlüğe konulan Yükseköğretim Kurumları Kısmi Zamanlı Öğrenci Çalıştırma Usul ve Esasları uyarınca çalıştırılacak öğrencilerde;

1- Tezisiz yüksek lisans ve özel öğrenci hariç olmak üzere, Kocaeli Üniversitesinde kayıtlı öğrenci olmak,
2- Disiplin cezası almamış olmak,
3- Yetim maaşı ve nafaka hariç asgari ücret düzeyinde bir gelire sahip olmamak,
4- Kısmi zamanlı çalıştırılan öğrenci ile Üniversitemiz arasında yapılan sözleşmeye aykırılık nedeniyle sözleşmesi feshedilmemiş olmak,
5- Çalıştırılacak iş için yeterli bilgi, beceri ve yeteneğe sahip olmak,
6- Kayıt donduran öğrenci ve yabancı öğrenci olmamak,
7- Normal eğitim-öğretim süresinde öğrenim görüyor olmak Deprem,sel gibi doğal afetlerden zarar gördüğünü, şehit veya gazi çocuğu olduğunu belgeleyen öğrenciler ve engelli öğrencilerden 2. 6. ve 7. maddeler dışında yukarıdaki şartlar aranmaz.

Başvuru belgeleri aşağıda sunulmakta olup, Kısmi Zamanlı Öğrenci Çalıştırma Başvuru Formu ile birlikte ilgili Fakülte/Yüksekokul/Enstitü/Meslek Yüksekokulu/ Daire Başkanlıklarına yapılacaktır.

Başvuru süresi ilanın tarihinden itibaren 03/01/2025 tarihine kadardır.`
  });
  const [announcementEndDate, setAnnouncementEndDate] = useState(""); // NEW
  const [isAnnouncementActive, setIsAnnouncementActive] = useState(true);
  const contentRef = useRef(null);           // NEW: scroll container ref
  const scrollPosRef = useRef(0);            // NEW: remember scroll
  const navigate = useNavigate(); // NEW


  const [puEmployees, setPuEmployees] = useState([]);
  const [puLoading, setPuLoading] = useState(false);
  // NEW: modal state for employee detail
  const [puDetailOpen, setPuDetailOpen] = useState(false);
  const [puDetailLoading, setPuDetailLoading] = useState(false);
  const [puDetailData, setPuDetailData] = useState(null);
  const [puTerminating, setPuTerminating] = useState(false);

  // NEW: monthly puantaj view state for selected unit
  const [puMonthlyOpen, setPuMonthlyOpen] = useState(false);
  const [puMonthlyMonth, setPuMonthlyMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });
  const [puMonthlyLoading, setPuMonthlyLoading] = useState(false);
  const [puMonthlyData, setPuMonthlyData] = useState(null);
  const [puMonthlyApproved, setPuMonthlyApproved] = useState(false); // NEW


  // Eksik state tanımları
const [puantajFilterActive, setPuantajFilterActive] = useState(false); // Filtre aktif mi?
const [puantajApprovedUnitsMap, setPuantajApprovedUnitsMap] = useState({}); // Onaylı birimler


  const getAdminUser = () => {
    try {
      const s1 = sessionStorage.getItem('adminUser');
      if (s1) return JSON.parse(s1);
      const l1 = localStorage.getItem('adminUser');
      if (l1) return JSON.parse(l1);
      const fallback = localStorage.getItem('user');
      if (fallback) {
        const u = JSON.parse(fallback);
        return u?.type === 'admin' ? u : null;
      }
      return null;
    } catch {
      return null;
    }
  };

  // Verileri getir
  useEffect(() => {
    // Admin oturumu yoksa veri çekme ve uyar
    const admin = getAdminUser();
    if (!admin) {
      console.warn("Admin oturumu bulunamadı");
      // İsterseniz girişe yönlendirin:
      // window.location.replace("/");
      return;
    }

    fetchData();
    // Load saved announcement from localStorage
    const saved = localStorage.getItem("announcementData");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed?.title && typeof parsed.content === "string") {
          setAnnouncement(parsed);
        }
      } catch (e) {
        console.error("Announcement data parse error:", e);
      }
    }
    // NEW: load saved end date
    const savedEnd = localStorage.getItem("announcementEndDate");
    if (typeof savedEnd === "string") setAnnouncementEndDate(savedEnd);

    // Load announcement status
    const announcementStatus = localStorage.getItem("announcementActive");
    if (announcementStatus !== null) {
      setIsAnnouncementActive(JSON.parse(announcementStatus));
    }

    // NEW: trigger daily reminder tick (safe to call multiple times/day)
    (async () => { try { await api.post("/admin/reminders/period-end/tick"); } catch {} })();
  }, []);


  const fetchData = async () => {
    try {
      setLoading(true);
      const [institutionsRes, unitsRes] = await Promise.all([
        api.get("/admin/upper-institutions"),
        api.get("/admin/units"),
      ]);

      if (institutionsRes.data.success) {
        setInstitutions(institutionsRes.data.data);
      }
      if (unitsRes.data.success) {
        setUnits(unitsRes.data.data);
      }
    } catch (error) {
      console.error("Veriler getirilirken hata:", error);
    } finally {
      setLoading(false);
    }
  };

  // NEW: puantaj counts and expand state (fix no-undef)
  const [puantajCounts, setPuantajCounts] = useState({});
  const [expandedPuantajInstitution, setExpandedPuantajInstitution] = useState(null);

  // NEW: fetch puantaj meta (active employee counts per unit)
  const fetchPuantajMeta = async () => {
    try {
      const resp = await api.get("/admin/puantaj/meta");
      if (resp.data?.success) {
        setPuantajCounts(resp.data.data?.counts || {});
      } else {
        setPuantajCounts({});
      }
    } catch (e) {
      setPuantajCounts({});
    }
  };

  // Onaylanmış timesheet olan birimleri backend'den çek
const fetchPuantajApprovedUnits = async () => {
  try {
    const resp = await api.get("/admin/puantaj/approved-units");
    if (resp.data?.success) {
      setPuantajApprovedUnitsMap(resp.data.data || {});
    } else {
      setPuantajApprovedUnitsMap({});
    }
  } catch {
    setPuantajApprovedUnitsMap({});
  }
};

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // Modal kapandıktan sonra verileri yenile
    fetchData();
  };

  const toggleInstitution = (institutionId) => {
    const newExpanded = expandedInstitution === institutionId ? null : institutionId;
    setExpandedInstitution(newExpanded);
    
    // Dropdown açıldığında elementi görünür alana kaydır
    if (newExpanded !== null) {
      setTimeout(() => {
        const element = document.getElementById(`institution-${institutionId}`);
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }, 100);
    }
  };

  // NEW: toggle expand for puantaj section
  const togglePuantajInstitution = (institutionId) => {
    const newExpanded = expandedPuantajInstitution === institutionId ? null : institutionId;
    setExpandedPuantajInstitution(newExpanded);
    if (newExpanded !== null) {
      setTimeout(() => {
        const element = document.getElementById(`puantaj-${institutionId}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }, 100);
    }
  };

  const getUnitsByInstitution = (institutionId) => {
    return units.filter((unit) => unit.ustBirim._id === institutionId);
  };

  // NEW: only units with active employees
  const getActiveUnitsByInstitution = (institutionId) => {
    return getUnitsByInstitution(institutionId).filter(u => puantajCounts[u._id] > 0);
  };

  // Filtreli üst kurumları döndür (sadece onaylı birim içerenler)
const getFilteredPuantajInstitutions = () => {
  if (!puantajFilterActive) return getActivePuantajInstitutions();
  const approvedUnitIds = Object.keys(puantajApprovedUnitsMap).filter(uid => puantajApprovedUnitsMap[uid]);
  const unitsWithApproved = units.filter(u => approvedUnitIds.includes(u._id));
  const instIds = new Set(unitsWithApproved.map(u => u.ustBirim._id));
  return institutions.filter(inst => instIds.has(inst._id));
};

// Filtreli birimleri döndür (sadece onaylı birimler)
const getFilteredActiveUnitsByInstitution = (institutionId) => {
  if (!puantajFilterActive) return getActiveUnitsByInstitution(institutionId);
  const approvedUnitIds = Object.keys(puantajApprovedUnitsMap).filter(uid => puantajApprovedUnitsMap[uid]);
  return getUnitsByInstitution(institutionId).filter(u => approvedUnitIds.includes(u._id));
};

  // Open detail: remember scroll, then set selection
  const openUnitDetail = (sicilNo) => {
    if (contentRef.current) {
      scrollPosRef.current = contentRef.current.scrollTop || 0;
    }
    setSelectedUnit(sicilNo);
  };

  // Back to list: clear selection and restore scroll
  const backToUnitsList = () => {
    setSelectedUnit(null);
    // wait next paint so list mounts, then restore scroll
    setTimeout(() => {
      if (contentRef.current) {
        contentRef.current.scrollTo({ top: scrollPosRef.current, behavior: "auto" });
      }
    }, 0);
  };

  // Fetch selected unit details by sicilNo
  useEffect(() => {
    const fetchSelectedUnit = async () => {
      try {
        setSelectedUnitLoading(true);
        setSelectedUnitData(null);
        const res = await api.get(`/admin/units/${selectedUnit}`);
        if (res.data?.success) {
          setSelectedUnitData(res.data.data);
        }
      } catch (e) {
        console.error("Admin selected unit fetch error:", e);
      } finally {
        setSelectedUnitLoading(false);
      }
    };
    if (selectedUnit) fetchSelectedUnit();
  }, [selectedUnit]);

  // Download latest asil-yedek list PDF for the selected unit
  const downloadLatestAsilYedek = async () => {
    try {
      if (!selectedUnit) return;
      const resp = await api.get(`/unit/${selectedUnit}/asil-yedek/latest`, {
        responseType: "blob",
      });
      if (resp.status === 204 || (resp.data instanceof Blob && resp.data.size === 0)) {
        alert("Bu birime ait kayıtlı asil-yedek listesi bulunamadı.");
        return;
      }
      const blob = new Blob([resp.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const unitName = (selectedUnitData?.birimAdi || String(selectedUnit)).replace(/\s+/g, "_");
      link.href = url;
      link.download = `asil_yedek_listesi_${unitName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      if (e.response?.status === 404) {
        alert("Bu birime ait kayıtlı asil-yedek listesi bulunamadı.");
      } else {
        alert("İndirme sırasında bir hata oluştu.");
      }
      console.error("Admin download latest asil-yedek error:", e);
    }
  };

  // Preview state (unique to admin preview)
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewError, setPreviewError] = useState("");

  // NEW: Application documents panel state
  const [isDocsPanelOpen, setIsDocsPanelOpen] = useState(false);
  const [docsAppId, setDocsAppId] = useState(null);
  const [docsLoading, setDocsLoading] = useState(false);
  const [docsItems, setDocsItems] = useState([]); // [{ requirementId, requirementKey, requirementName, ... }]
  const [docsStudentName, setDocsStudentName] = useState(""); // NEW: keep student name for ZIP naming

  // NEW: Reject documents modal state
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectType, setRejectType] = useState("resubmit"); // "resubmit" or "final"
  const [rejectReason, setRejectReason] = useState("");
  const [rejecting, setRejecting] = useState(false);

  // NEW: admin approval + asil apps
  const [asilMeta, setAsilMeta] = useState({ exists: false, adminApproved: false });
  const [asilApps, setAsilApps] = useState([]);
  const [asilLoading, setAsilLoading] = useState(false);

  // Open latest PDF preview
  const openPreviewLatestAsilYedek = async () => {
    try {
      if (!selectedUnit) return;
      setPreviewLoading(true);
      setPreviewError("");
      const resp = await api.get(`/unit/${selectedUnit}/asil-yedek/latest`, { responseType: "blob" });
      if (resp.status === 204 || (resp.data instanceof Blob && resp.data.size === 0)) {
        setPreviewLoading(false);
        alert("Bu birime ait kayıtlı asil-yedek listesi bulunamadı.");
        return;
      }
      // revoke previous
      if (previewUrl) window.URL.revokeObjectURL(previewUrl);
      const blob = resp?.data instanceof Blob ? resp.data : new Blob([resp.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      setPreviewUrl(url);
      setIsPreviewOpen(true);
    } catch (e) {
      setPreviewLoading(false);
      setPreviewError("Önizleme yüklenemedi.");
      if (e.response?.status === 404) {
        alert("Bu birime ait kayıtlı asil-yedek listesi bulunamadı.");
      } else {
        alert("Önizleme yüklenirken hata oluştu.");
      }
      console.error("Admin preview latest asil-yedek error:", e);
    }
  };

  // Close preview and cleanup
  const closePreview = () => {
    setIsPreviewOpen(false);
    setPreviewLoading(false);
    setPreviewError("");
    if (previewUrl) {
      window.URL.revokeObjectURL(previewUrl);
      setPreviewUrl(null);
    }
  };

  // Helper: extract filename from content-disposition header
 // Helper: extract filename from content-disposition header
const getFileNameFromDisposition = (disposition) => {
  try {
    if (!disposition) return null;
    
    // Try RFC 5987 format first (filename*=UTF-8''...)
    const rfc5987Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (rfc5987Match) {
      return decodeURIComponent(rfc5987Match[1]);
    }
    
    // Fallback to simple filename="..."
    const simpleMatch = disposition.match(/filename="([^"]+)"/i);
    if (simpleMatch) {
      return simpleMatch[1];
    }
    
    // Last resort: filename=... (no quotes)
    const noQuotesMatch = disposition.match(/filename=([^;]+)/i);
    if (noQuotesMatch) {
      return decodeURIComponent(noQuotesMatch[1].trim());
    }
    
    return null;
  } catch (e) {
    console.error("Filename extraction error:", e);
    return null;
  }
};

  // NEW: open docs panel for an application (fetch uploaded requirement documents)
 const openDocsForApplication = async (applicationId, studentName) => {
  try {
    setIsPreviewOpen(false);
    setDocsAppId(applicationId);
    setDocsStudentName(studentName || "");
    setDocsLoading(true);
    setDocsItems([]);
    
    const resp = await api.get(`/admin/applications/${applicationId}/documents`);
    
    // ADDED: Detailed logging
    console.log("=== Documents Response ===");
    console.log("Success:", resp.data?.success);
    console.log("Documents array length:", resp.data?.data?.documents?.length);
    console.log("UploadedMap keys:", Object.keys(resp.data?.data?.uploadedMap || {}));
    console.log("Full documents:", resp.data?.data?.documents);
    
    if (resp.data?.success) {
      const docs = resp.data.data?.documents || [];
      console.log(`Setting ${docs.length} documents to state`);
      setDocsItems(docs);
    }
    setIsDocsPanelOpen(true);
  } catch (e) {
    alert("Belgeler getirilirken hata oluştu.");
    console.error("Admin get documents error:", e);
  } finally {
    setDocsLoading(false);
  }
};

  const closeDocsPanel = () => {
    setIsDocsPanelOpen(false);
    setDocsAppId(null);
    setDocsItems([]);
    setDocsStudentName("");                           // NEW: reset
  };

  // NEW: Open reject modal
  const openRejectModal = () => {
    setRejectType("resubmit");
    setRejectReason("");
    setRejectModalOpen(true);
  };

  // NEW: Close reject modal
  const closeRejectModal = () => {
    setRejectModalOpen(false);
    setRejectType("resubmit");
    setRejectReason("");
  };

  // NEW: Confirm rejection
  const confirmReject = async () => {
    if (!rejectReason.trim()) {
      alert("Lütfen red sebebini giriniz.");
      return;
    }

    try {
      setRejecting(true);
      await api.post(`/admin/applications/${docsAppId}/reject-documents`, {
        rejectType,
        reason: rejectReason.trim()
      });

      alert(
        rejectType === "resubmit"
          ? "Belgeler reddedildi. Öğrenci yeniden yükleyebilir."
          : "Başvuru reddedildi ve iptal edildi."
      );

      // Close modal and docs panel
      closeRejectModal();
      closeDocsPanel();

      // Refresh the list
      if (selectedUnit) {
        fetchAsilApps(selectedUnit);
      }
    } catch (e) {
      alert("Red işlemi başarısız oldu.");
      console.error("Reject documents error:", e);
    } finally {
      setRejecting(false);
    }
  };

  // NEW: download specific requirement document
 // NEW: download specific requirement document
const downloadRequirementDoc = async (applicationId, requirementId, fallbackName) => {
  try {
    const resp = await api.get(`/admin/applications/${applicationId}/documents/${requirementId}`, {
      responseType: "blob"
    });
    
    const blob = new Blob([resp.data]);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    
    // ✅ FIX: Extract filename from Content-Disposition header
    const cd = resp.headers?.["content-disposition"];
    let fileName = getFileNameFromDisposition(cd);
    
    // ✅ If no filename in header, construct from Content-Type
    if (!fileName) {
      const contentType = resp.headers?.["content-type"] || "application/pdf";
      const ext = getExtensionFromContentType(contentType);
      fileName = `${fallbackName || "belge"}_${requirementId}${ext}`;
    }
    
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (e) {
    alert("Belge indirilemedi.");
    console.error("Admin download requirement doc error:", e);
  }
};

// ✅ NEW: Helper to get extension from Content-Type
const getExtensionFromContentType = (contentType) => {
  const map = {
    'application/pdf': '.pdf',
    'application/msword': '.doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
    'application/vnd.ms-excel': '.xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'image/gif': '.gif',
    'image/webp': '.webp',
    'text/plain': '.txt',
    'application/zip': '.zip',
    'application/x-rar-compressed': '.rar',
    'application/octet-stream': '' // fallback
  };
  return map[contentType] || '.pdf'; // default fallback to PDF
};

  // NEW: download original application PDF
  const downloadApplicationPdf = async (applicationId) => {
    try {
      const resp = await api.get(`/unit/applications/${applicationId}/document`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `basvuru_${applicationId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      alert("Başvuru belgesi indirilemedi.");
      console.error("Admin download application pdf error:", e);
    }
  };

  // Fetch latest meta for selected unit
  const fetchAsilMeta = async (sicil) => {
    try {
      const resp = await api.get(`/admin/units/${sicil}/asil-yedek/latest-meta`);
      if (resp.data?.success) setAsilMeta(resp.data.data || { exists: false, adminApproved: false });
    } catch {
      setAsilMeta({ exists: false, adminApproved: false });
    }
  };

  // Fetch asil applications for selected unit
  const fetchAsilApps = async (sicil) => {
    try {
      setAsilLoading(true);
      const resp = await api.get(`/admin/units/${sicil}/asil-applications`);
      if (resp.data?.success) setAsilApps(resp.data.data || []);
    } catch {
      setAsilApps([]);
    } finally {
      setAsilLoading(false);
    }
  };

  // On unit selection or change, refresh meta and apps (if approved)
  useEffect(() => {
    if (selectedUnit) {
      fetchAsilMeta(selectedUnit);
    } else {
      setAsilMeta({ exists: false, adminApproved: false });
      setAsilApps([]);
    }
  }, [selectedUnit]);

  useEffect(() => {
    if (selectedUnit && asilMeta.adminApproved) {
      fetchAsilApps(selectedUnit);
    } else {
      setAsilApps([]);
    }
  }, [selectedUnit, asilMeta.adminApproved]);

  // Approve latest list
  const approveLatestList = async () => {
    if (!selectedUnit) return;
    if (!window.confirm("Bu birimin son asil-yedek listesini onaylamak istiyor musunuz?")) return;
    try {
      const resp = await api.post(`/admin/units/${selectedUnit}/asil-yedek/approve-latest`);
      if (resp.data?.success) {
        alert("Liste onaylandı.");
        setIsPreviewOpen(false);
        await fetchAsilMeta(selectedUnit);
        await fetchAsilApps(selectedUnit);
      } else {
        alert(resp.data?.message || "Onay işlemi başarısız.");
      }
    } catch (e) {
      alert(e.response?.data?.message || "Onay işlemi sırasında hata oluştu.");
    }
  };

  // NEW: mark insurance entry as done for current docs application
  const markInsuranceDone = async () => {
    try {
      if (!docsAppId) return;
      const resp = await api.post(`/admin/applications/${docsAppId}/insurance/done`);
      if (resp.data?.success) {
        alert("Sigorta girişi yapıldı.");
        if (selectedUnit) {
          await fetchAsilApps(selectedUnit); // refresh table to show "Giriş Yapıldı"
        }
      } else {
        alert(resp.data?.message || "Sigorta girişi güncellenemedi.");
      }
    } catch (e) {
      alert(e.response?.data?.message || "Sigorta girişi sırasında hata oluştu.");
    }
  };

  // Lazy-load jsPDF + autotable for PDF export
  const loadJsPdf = useCallback(() =>
    new Promise((resolve, reject) => {
      if (window.jspdf?.jsPDF && window.jspdf?.autoTable) return resolve(window.jspdf);
      const script1 = document.createElement("script");
      script1.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
      script1.onload = () => {
        const script2 = document.createElement("script");
        script2.src = "https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.5.28/jspdf.plugin.autotable.min.js";
        script2.onload = () => resolve(window.jspdf);
        script2.onerror = reject;
        document.head.appendChild(script2);
      };
      script1.onerror = reject;
      document.head.appendChild(script1);
    })
  , []);

  const downloadMonthlyExcel = async () => {
  if (!puMonthlyData || !puMonthlyData.rows || !puMonthlyMonth) {
    alert("Tablo verisi bulunamadı.");
    return;
  }
  // xlsx kütüphanesini dinamik yükle
  if (!window.XLSX) {
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://cdn.sheetjs.com/xlsx-0.20.0/package/dist/xlsx.full.min.js";
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  const XLSX = window.XLSX;
  const month = puMonthlyMonth;
  const rows = puMonthlyData.rows;

  // Başlıklar
  const header = [
    "Sıra",
    "Ad Soyad",
    "Sicil No",
    "Toplam Saat",
    "Toplam Ücret",
    ...puMonthlyData.days.map(d => d.date) // Her gün için bir sütun
  ];

  // Satırları oluştur
  const data = rows.map((r, idx) => {
    const perDay = r.perDay || {};
    return [
      idx + 1,
      r.studentName || "",
      r.studentSicilNo || "",
      r.totalHours || 0,
      (r.monthlyAmount || 0) + " TL",
      ...puMonthlyData.days.map(d => perDay[d.day] || 0)
    ];
  });

  // Sheet oluştur
  const ws = XLSX.utils.aoa_to_sheet([header, ...data]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Aylık Puantaj");

  // Dosya adını oluştur
  const safeName = (puSelectedUnitName || "birim")
    .toString()
    .replace(/ğ/g, 'g').replace(/Ğ/g, 'G')
    .replace(/ü/g, 'u').replace(/Ü/g, 'U')
    .replace(/ş/g, 's').replace(/Ş/g, 'S')
    .replace(/ı/g, 'i').replace(/İ/g, 'I')
    .replace(/ö/g, 'o').replace(/Ö/g, 'O')
    .replace(/ç/g, 'c').replace(/Ç/g, 'C')
    .replace(/[^a-zA-Z0-9]/g, '_');
  const fileName = `Aylik_Puantaj_${safeName}_${month}.xlsx`;

  XLSX.writeFile(wb, fileName);
};

  // Simple "Detay" button handler (can be extended later)
  const showPuantajDetail = async (emp) => {
    try {
      setPuDetailOpen(true);
      setPuDetailLoading(true);
      setPuDetailData(null);
      if (!emp?.applicationId) {
        setPuDetailLoading(false);
        return;
      }
      const resp = await api.get(`/admin/puantaj/employee/${emp.applicationId}/detail`);
      if (resp.data?.success) {
        setPuDetailData(resp.data.data || null);
      } else {
        setPuDetailData(null);
      }
    } catch {
      setPuDetailData(null);
    } finally {
      setPuDetailLoading(false);
    }
  };

  // NEW: terminate (sigorta çıkışı) and refresh list
  const terminateEmployee = async () => {
    try {
      if (!puDetailData?.applicationId) return;
      if (!window.confirm("Bu öğrenci için sigorta çıkışını vermek istiyor musunuz?")) return;
      setPuTerminating(true);
      const resp = await api.post(`/admin/puantaj/employee/${puDetailData.applicationId}/terminate`);
      if (resp.data?.success) {
        alert("Sigorta çıkışı verildi.");
        setPuDetailOpen(false);
        // refresh current unit list
        if (puSelectedUnit) {
          await openPuantajUnit(puSelectedUnit, puSelectedUnitName);
        }
      } else {
        alert(resp.data?.message || "İşlem gerçekleştirilemedi.");
      }
    } catch (e) {
      alert(e?.response?.data?.message || "İşlem sırasında bir hata oluştu.");
    } finally {
      setPuTerminating(false);
    }
  };

  // Fetch puantaj counts when tab opens (and refresh when switching back)
  useEffect(() => {
    if (activeTab === "puantaj") {
      setSearchQuery("");
      fetchPuantajMeta();
      fetchPuantajApprovedUnits(); // NEW: onaylı birimleri çek
      setSelectedUnit(null);
      setPuSelectedUnit(null);
      setPuSelectedUnitName("");
      setExpandedInstitution(null);           // EKLENDİ: Birimler dropdown kapansın
      setExpandedPuantajInstitution(null);    // EKLENDİ: Puantaj dropdown kapansın
      // Birimler sekmesi state'lerini temizle
      setAsilMeta({ exists: false, adminApproved: false });
      setAsilApps([]);
    }
    else if (activeTab === "birimler") {
            setSearchQuery("");

      setSelectedUnit(null);
      setPuSelectedUnit(null);
      setPuSelectedUnitName("");
      setExpandedInstitution(null);           // EKLENDİ
      setExpandedPuantajInstitution(null);    // EKLENDİ
      // Asil meta'yı temizle - birim detayına girince güncellenecek
      setAsilMeta({ exists: false, adminApproved: false });
      setAsilApps([]);
    }
    else {
            setSearchQuery("");

      setPuSelectedUnit(null);
      setPuSelectedUnitName("");
      setSelectedUnit(null);
      setExpandedInstitution(null);           // EKLENDİ
      setExpandedPuantajInstitution(null);    // EKLENDİ
      setAsilMeta({ exists: false, adminApproved: false });
      setAsilApps([]);
    }
  }, [activeTab]); // only when Puantaj tab is active



const openPuantajUnit = async (sicilNo, unitName) => {
  setPuSelectedUnit(sicilNo);
  setPuSelectedUnitName(unitName || "");
  setPuLoading(true);
  try {
    const currentMonth = new Date();
    const monthParam = `${currentMonth.getFullYear()}-${String(currentMonth.getMonth() + 1).padStart(2, "0")}`;

    // ✅ Aylık veriyi isteğe dahil et
    const resp = await api.get(`/admin/puantaj/unit/${sicilNo}/employees`, {
      params: { month: monthParam }
    });

    if (resp.data?.success) {
      setPuEmployees(resp.data.data?.employees || []);
      if (!unitName) setPuSelectedUnitName(resp.data.data?.unit?.birimAdi || "");
    } else {
      setPuEmployees([]);
    }

    // NEW: Birim aylık tablo onaylı mı kontrol et
    await checkMonthlyApproved(sicilNo, monthParam);

  } catch {
    setPuEmployees([]);
    setPuMonthlyApproved(false);
  } finally {
    setPuLoading(false);
  }
};

  // NEW: check if the monthly puantaj is approved for the unit
  const checkMonthlyApproved = async (sicilNo, month) => {
    try {
      const resp = await api.get(`/unit/${sicilNo}/monthly-timesheet`, {
        params: { month, meta: 1 }
      });
      // Backend'den monthlyTimesheet endpoint'inde approved bilgisi dönmeli!
      setPuMonthlyApproved(!!resp.data?.meta?.approved);
    } catch {
      setPuMonthlyApproved(false);
    }
  };

  const closePuantajUnit = () => {
    setPuSelectedUnit(null);
    setPuSelectedUnitName("");
    setPuEmployees([]);
    setPuMonthlyOpen(false);         // NEW: ensure monthly view closes
    setPuMonthlyData(null);          // NEW
  };

  // NEW: fetch monthly puantaj data for selected unit
  const fetchPuMonthly = async (m) => {
    if (!puSelectedUnit) return;
    setPuMonthlyLoading(true);
    try {
      const resp = await api.get(`/unit/${puSelectedUnit}/monthly-timesheet`, {
        params: { month: m || puMonthlyMonth }
      });
      if (resp.data?.success) {
        setPuMonthlyData(resp.data.data || null);
      } else {
        setPuMonthlyData(null);
      }
    } catch {
      setPuMonthlyData(null);
    } finally {
      setPuMonthlyLoading(false);
    }
  };

  // NEW: open/close monthly view
  const openPuMonthly = () => {
    if (!puSelectedUnit) return;
    setPuMonthlyOpen(true);
    fetchPuMonthly(puMonthlyMonth);
  };
  const closePuMonthly = () => setPuMonthlyOpen(false);

  // NEW: month change handler for UnitMonthlyTable
  const onChangePuMonthlyMonth = (m) => {
    setPuMonthlyMonth(m);
    fetchPuMonthly(m);
  };

  // NEW: notifications state used by modal and header bell
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifOpen, setNotifOpen] = useState(false);
  const [notifLoading, setNotifLoading] = useState(false);

  // NEW: basic time ago helper for notifications
  const timeAgo = (d) => {
    try {
      const ts = new Date(d).getTime();
      const diff = Math.max(0, Date.now() - ts);
      const mins = Math.floor(diff / 60000);
      if (mins < 1) return "az önce";
      if (mins < 60) return `${mins} dk önce`;
      const hrs = Math.floor(mins / 60);
      if (hrs < 24) return `${hrs} saat önce`;
      const days = Math.floor(hrs / 24);
      return `${days} gün önce`;
    } catch { return ""; }
  };

  // NEW: notifications API helpers
  const fetchNotifications = async () => {
    try {
      const admin = getAdminUser();
      if (!admin?.sicilNo) return;
      setNotifLoading(true);
      const resp = await api.get(`/admin/notifications/${admin.sicilNo}`);
      if (resp.data?.success) {
        setNotifications(resp.data.data.notifications || []);
        setUnreadCount(resp.data.data.unreadCount || 0);
      }
    } catch {} finally {
      setNotifLoading(false);
    }
  };
  const openNotifications = async () => { await fetchNotifications(); setNotifOpen(true); };
  const closeNotifications = () => setNotifOpen(false);
  const markOneRead = async (id) => {
    try {
      await api.patch(`/admin/notifications/${id}/read`);
      setNotifications(prev => prev.map(n => n._id === id ? { ...n, goruldu: true } : n));
      setUnreadCount(prev => Math.max(0, prev - 1));
    } catch {}
  };
  const markAllRead = async () => {
    try {
      const admin = getAdminUser();
      if (!admin?.sicilNo) return;
      await api.patch(`/admin/notifications/${admin.sicilNo}/read-all`);
      setNotifications(prev => prev.map(n => ({ ...n, goruldu: true })));
      setUnreadCount(0);
    } catch {}
  };

  // NEW: header actions (bell + logout)
  const handleLogout = () => {
    try { delete api.defaults.headers.common["Authorization"]; } catch {}
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiresAt");
    localStorage.removeItem("user");
    localStorage.removeItem("adminUser");
    sessionStorage.removeItem("adminUser");
    navigate("/");
  };
  const HeaderActions = () => (
    <div className="header-actions">
                {activeTab === "birimler" ? (
  <button
    className="addUnit-button"
    title="Yeni Birim Ekle"
    onClick={openModal}
  >
    +
  </button>
) : (

    <button
    className="addUnit-button hidden-button"
    title="Yeni Birim Ekle"
    onClick={openModal}
  >
    +
  </button>
)}
      <button
        className="header-icon-btn"
        title="Bildirimler"
        onClick={openNotifications}
        style={{ background: unreadCount > 0 ? "#e9f7ef" : "#fff", position: "relative" }}
      >
        <i className="fa-solid fa-bell"></i>
        {unreadCount > 0 && (
          <span style={{
            position: "absolute", top: -6, right: -6, minWidth: 18, height: 18,
            padding: "0 4px", background: "#d72538", color: "#fff", borderRadius: 12,
            fontSize: 11, lineHeight: "18px", textAlign: "center", boxShadow: "0 1px 4px rgba(0,0,0,0.2)"
          }}>
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>
      <button className="header-icon-btn" title="Çıkış Yap" onClick={handleLogout}>
        <i className="fa-solid fa-arrow-right-from-bracket"></i>
      </button>
    </div>
  );

  // NEW: ilan actions used by buttons
  const saveAnnouncement = () => {
    localStorage.setItem("announcementData", JSON.stringify(announcement));
    localStorage.setItem("announcementEndDate", announcementEndDate || "");
    localStorage.setItem("announcementHourlyWage", announcementHourlyWage || "88.90");
    alert("İlan başarıyla kaydedildi!");
    // NEW: persist period settings for reminders
    (async () => {
      try {
        await api.post("/admin/period-settings", {
          endDate: announcementEndDate || null,
          isActive: isAnnouncementActive
        });
      } catch {}
    })();
  };
  const resetAnnouncement = () => {
    localStorage.removeItem("announcementData");
    localStorage.removeItem("announcementEndDate");
    localStorage.removeItem("announcementHourlyWage");
    setAnnouncement({
      title: "KISMI ZAMANLI ÇALIŞACAK ÖĞRENCİLERİN ALIM İLANI",
      content: `Üniversitemiz 11/09/2024 tarihli ve 2024/9 nolu toplantısında alınan 97 sıra sayılı Yönetim Kurulu Kararına istinaden aylık KZÖ çalışma 30 saat ile sınırlandırılmıştır.

Çalışma saati brüt ücreti, 2025 yılı brüt saatlik asgari ücret karşılığı kısmi zamanlı çalışacak öğrenci kontenjanları, çalıştırılacak yer ve işin niteliği birimler itibarıyle belirlenmiş olup aşağıdaki listede belirtilmiştir.

Öğrencilerin çalışma süresi haftada en fazla 15 saat olup, 01.09.2009 tarihinden itibaren Yüksek Öğretim Kurulu tarafından yürürlüğe konulan Yükseköğretim Kurumları Kısmi Zamanlı Öğrenci Çalıştırma Usul ve Esasları uyarınca çalıştırılacak öğrencilerde;

1- Tezisiz yüksek lisans ve özel öğrenci hariç olmak üzere, Kocaeli Üniversitesinde kayıtlı öğrenci olmak,
2- Disiplin cezası almamış olmak,
3- Yetim maaşı ve nafaka hariç asgari ücret düzeyinde bir gelire sahip olmamak,
4- Kısmi zamanlı çalıştırılan öğrenci ile Üniversitemiz arasında yapılan sözleşmeye aykırılık nedeniyle sözleşmesi feshedilmemiş olmak,
5- Çalıştırılacak iş için yeterli bilgi, beceri ve yeteneğe sahip olmak,
6- Kayıt donduran öğrenci ve yabancı öğrenci olmamak,
7- Normal eğitim-öğretim süresinde öğrenim görüyor olmak Deprem,sel gibi doğal afetlerden zarar gördüğünü, şehit veya gazi çocuğu olduğunu belgeleyen öğrenciler ve engelli öğrencilerden 2. 6. ve 7. maddeler dışında yukarıdaki şartlar aranmaz.

Başvuru belgeleri aşağıda sunulmakta olup, Kısmi Zamanlı Öğrenci Çalıştırma Başvuru Formu ile birlikte ilgili Fakülte/Yüksekokul/Enstitü/Meslek Yüksekokulu/ Daire Başkanlıklarına yapılacaktır.

Başvuru süresi ilanın tarihinden itibaren 03/01/2025 tarihine kadardır.`
    });
    setAnnouncementEndDate("");
    setAnnouncementHourlyWage("88.90");
  };
  const toggleAnnouncementStatus = () => {
    const newStatus = !isAnnouncementActive;
    setIsAnnouncementActive(newStatus);
    localStorage.setItem("announcementActive", JSON.stringify(newStatus));
    alert(newStatus ? "İlan yayınlandı! Öğrenciler artık başvuru yapabilir." : "İlan yayından kaldırıldı. Öğrenciler başvuru yapamayacak.");
  };

  // NEW: Birimler sekmesi içeriği (compact)
  const renderBirimlerContent = () => {
      // 1) Docs Panel for a single student's application (same apv-shell CSS)
      if (selectedUnit && isDocsPanelOpen) {
        // Standard requirements catalog for labeling/buttons
        const requirements = [
          { id: 1, key: "contract", name: "Kısmi Zamanlı Öğrenci Çalıştırma Sözleşmesi" },
          { id: 2, key: "ogrenci-belgesi", name: "Yeni Tarihli Öğrenci Belgesi" },
          { id: 3, key: "aile-saglik", name: "Aile Sağlık Yardımı Sorgulama Belgesi" },
          { id: 4, key: "kimlik", name: "Kimlik Fotokopisi" },
          { id: 5, key: "iban", name: "İban Gösterir Belge" }
        ];
        const docMap = new Map(docsItems.map(d => [d.requirementId, d]));
  
        return (
          <div className="apv-shell2">
            <button
              className="apv-side-btn2 apv-back-side2"
              onClick={closeDocsPanel}
              title="Geri Dön"
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>
  
            <div className="apv-viewer2">
              <div className="apv-viewer-content2">
                <div className="apv-pdf-container2">
                  {/* Documents list inside viewer */}
                  <div className="apv-docs">
                    <h3 className="apv-docs-title">
                      Belge İndir
                    </h3>
  
                    {/* Application document row */}
                    <div className="apv-doc-row">
                      <div className="apv-doc-name">Başvuru Belgesi</div>
                      <button
                        className="aud-st-doc-btn"
                        onClick={() => downloadApplicationPdf(docsAppId)}
                        title="Başvuru Belgesini İndir"
                      >
                        <i className="fa-solid fa-download"></i>
                      </button>
                    </div>
  
                    {/* Requirement documents rows */}
                    {requirements.map(req => {
                      const uploaded = docMap.get(req.id);
                      return (
                        <div key={req.id} className="apv-doc-row">
                          <div className="apv-doc-name">
                            {req.name}
                            {!uploaded && <span className="apv-doc-missing">(yüklenmemiş)</span>}
                          </div>
                          <button
                            className="aud-st-doc-btn"
                            onClick={() => uploaded && downloadRequirementDoc(docsAppId, req.id, req.key)}
                            title={uploaded ? "Belgeyi İndir" : "Belge mevcut değil"}
                            disabled={!uploaded}
                          >
                            <i className="fa-solid fa-download"></i>
                          </button>
                        </div>
                      );
                    })}
  
                    {docsLoading && (
                      <div className="apv-docs-loading">Yükleniyor...</div>
                    )}
                  </div>

                </div>
                    
            </div>
            </div>
  
            {/* Actions: onay + red + indir yan yana */}
            <div className="apv-actions2">
              <button
                className="apv-side-btn2 apv-download-side2"
                aria-hidden="true"
                tabIndex={-1}
                title="İndir"
                onClick={downloadAllDocsZip}
              >
                <i className="fa-solid fa-download"></i>
              </button>
              <button
                className="apv-side-btn2 apv-reject-side2"
                aria-hidden="true"
                tabIndex={-1}
                title="Reddet"
                onClick={openRejectModal}
              >
                <i className="fa-solid fa-times"></i>
              </button>
              <button
                className="apv-side-btn2 apv-approve-side2"
                aria-hidden="true"
                tabIndex={-1}
                title="Onayla"
                onClick={markInsuranceDone}
              >
                <i className="fa-solid fa-check"></i>
              </button>
  
            </div>
          </div>
        );
      }
  
      // 2) Preview page for selected unit
      if (selectedUnit && isPreviewOpen) {
        return (
          <div className="apv-shell">
            <button
              className="apv-side-btn apv-back-side"
              onClick={closePreview}
              title="Geri Dön"
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>
  
            <div className="apv-viewer">
              <div className="apv-viewer-content">
                <div className="apv-pdf-container">
                  {previewLoading && (
                    <div className="apv-preview-loading">Yükleniyor...</div>
                  )}
                  {previewError && (
                    <div className="apv-preview-error">{previewError}</div>
                  )}
                  {!previewError && previewUrl && (
                    <iframe
                      className="apv-pdf-iframe"
                      src={previewUrl}
                      title="Asil Yedek Listesi Önizleme"
                      onLoad={() => setPreviewLoading(false)}
                      onError={() => {
                        setPreviewLoading(false);
                        setPreviewError("Önizleme yüklenemedi.");
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
  
            <button
              className="apv-side-btn apv-download-side"
              onClick={approveLatestList}
              title="Onayla"
            >
              <i className="fa-solid fa-check"></i>
            </button>
          </div>
        );
      }
  
      // REPLACED: unit detail view
      if (selectedUnit) {
        if (selectedUnitLoading || !selectedUnitData) {
          return (
            <div className="aud-detail">
              <button className="aud-back-btn" onClick={backToUnitsList} title="Geri">
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <div className="aud-loading">Yükleniyor...</div>
            </div>
          );
        }
  
        const u = selectedUnitData;
        return (
          <div className="aud-detail">
            <div className="aud-titlebar">
              <div className="aud-title">Kısmi Zamanlı Öğrenci Asil ve Yedek Listesi</div>
              <div className="aud-actions">
                <button className="aud-icon-btn" title="İndir" onClick={downloadLatestAsilYedek}>
                  <i className="fa-solid fa-download"></i>
                </button>
                <button className="aud-icon-btn" title="Önizle" onClick={openPreviewLatestAsilYedek}>
                  <i className="fa-solid fa-eye"></i>
                </button>
  
              </div>
            </div>
  
            <div className="aud-meta">
              <div className="aud-meta-left">
                <div className="aud-unit-name">{u.birimAdi}</div>
                <div className="aud-unit-sub">{u.ustBirim?.ustKurum || ""} • Sicil: {u.sicilNo}  Şifre: {u.password}</div>
              </div>
              <div className="aud-meta-right">
                <span className="aud-kontenjan-label">Kontenjan Sayısı :</span>
                <span className="aud-kontenjan-value">{u.totalKapasite}</span>
              </div>
            </div>
  
            <div className="aud-table">
              <table>
                <thead>
                  <tr>
                    <th>Çalıştırılacak Yer</th>
                    <th>İşin Adı / Niteliği</th>
                    <th>Kontenjan Sayısı</th>
                  </tr>
                </thead>
                <tbody>
                  {(u.workplaces || []).map((wp) => (
                    <tr key={wp._id}>
                      <td>{wp.calisacakYer}</td>
                      <td>{wp.isAdi}</td>
                      <td>{wp.kapasite}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
  
            {/* REPLACED: empty state -> show asil table when approved */}
            {asilMeta.adminApproved ? (
              <div className="aud-students-empty aud-has-table">
                <div className="aud-st-scroll">
                  <table className="aud-st-grid">
                    <thead>
                      <tr>
                        <th className="aud-st-col-sira">Sıra</th>
                        <th className="aud-st-col-tc">T.C Kimlik No</th>
                        <th className="aud-st-col-name">Ad – Soyad</th>
                        <th className="aud-st-col-sigorta">Sigorta Durumu</th>
                        <th className="aud-st-col-belge">Belge</th>
                      </tr>
                    </thead>
                    <tbody>
                      {asilLoading ? (
                        <tr><td colSpan={5} className="aud-st-loading">Yükleniyor...</td></tr>
                      ): asilApps.length === 0 ? (
                        <tr><td colSpan={5} className="aud-st-empty">Kayıt bulunamadı</td></tr>
                      ) : (
                        asilApps.map(item => (
                          <tr key={item.applicationId}>
                            <td className="aud-st-col-sira">{item.row}</td>
                            <td className="aud-st-col-tc">{item.studentTcNo}</td>
                            <td className="aud-st-col-name">{item.studentName}</td>
                            <td className="aud-st-col-sigorta">{item.insuranceStatus}</td>
                            <td className="aud-st-col-belge">
                              <button
                                className="aud-st-doc-btn"
                                title="Başvuru Belgesi"
                                type="button"
                                onClick={() => openDocsForApplication(item.applicationId, item.studentName)} // pass name
                              >
                                <i className="fa-regular fa-file-lines"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="aud-students-empty">
                <img src={adminHomeImg} alt="Öğrenci listesi" />
                <div className="aud-empty-text">
                  <p>Bu birime ait kayıtlı asil-yedek listesi bulunamadı.</p>
                  <p>Lütfen Kısmi Zamanlı Öğrenci Asil ve Yedek Listesi’ni onaylayın.</p>
                </div>
              </div>
            )}
  
            <button
              className="aud-back-btn"
              onClick={backToUnitsList}
              title="Geri"
              aria-label="Geri"
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>
          </div>
        );
      }
  
      
  
      if (loading) {
        return (
          <div className="loading-state">
            <p>Veriler yükleniyor...</p>
          </div>
        );
      }
  
      if (institutions.length === 0) {
        return (
          <div className="admin-empty-state">
            <img src={adminHomeImg} alt="Boş içerik" className="admin-empty-img" />
            <p>
              Henüz üst kurum eklenmemiş.
              <br />
              Önce üst kurum ekleyerek başlayabilirsin!
            </p>
          </div>
        );
      }
  
      return (
        <div className="institutions-list">
          {institutions.map((institution) => {
            const institutionUnits = getUnitsByInstitution(institution._id);
            const isExpanded = expandedInstitution === institution._id;
  
            return (
              <div key={institution._id} className="institution-item">
                <div
                  className="institution-header"
                  onClick={() => toggleInstitution(institution._id)}
                >
                  <div className="institution-info">
                    <h3 className="institution-name">{institution.ustKurum}</h3>
                    <span className="units-count">
                      {institutionUnits.length} birim
                    </span>
                  </div>
                          <div className="expand-icon">
                            <i className={`fa-solid ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                          </div>
                </div>
  
                {isExpanded && (
                  <div className="admin-units-dropdown">
                    {institutionUnits.length > 0 ? (
                      institutionUnits.map((unit) => (
                        <div key={unit._id} className="admin-unit-item">
                          <div className="admin-unit-info"
                              onClick={() => openUnitDetail(unit.sicilNo)} // CHANGED: use helper
                              role="button"
                              title="Birim detayını aç">
                            <div
                              className="admin-unit-name-section"
  
                            >
                              <span className="admin-unit-name">{unit.birimAdi}</span>
                              <span className="admin-unit-sicil">Sicil: {unit.sicilNo}</span>
                            </div>
                            <div className="admin-unit-capacity">
                              <span>Toplam: {unit.totalKapasite}</span>
                              <span className="admin-available-capacity">
                                Müsait: {unit.workplaces.reduce((total, wp) => total + wp.bosKontenjan, 0)}
                              </span>
                            </div>
                          </div>
                          <div className="admin-unit-workplaces">
                            {unit.workplaces.map((workplace, index) => (
                              <div key={index} className="admin-workplace-detail">
                                <div className="admin-workplace-info">
                                  <span className="admin-workplace-name">
                                    {workplace.calisacakYer} - {workplace.isAdi}
                                  </span>
                                  <div className="admin-workplace-capacity-info">
                                    <span className="admin-total-capacity">
                                      Toplam: {workplace.kapasite}
                                    </span>
                                    <span className="admin-available-workplace-capacity">
                                      Müsait: {workplace.bosKontenjan}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="no-units">
                        Bu üst kuruma bağlı birim bulunmamaktadır.
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      );
    };

  const downloadAllDocsZip = async () => {
  try {
    if (!docsAppId) return;
    if (!window.JSZip || !window.saveAs) {
      alert("İndirme için gerekli bileşenler yüklenemedi. Lütfen sayfayı yenileyin.");
      return;
    }
    const zip = new window.JSZip();
    const safeName = (docsStudentName || String(docsAppId))
      .toString()
      .replace(/[^\p{L}\p{N}_\-. ]+/gu, "")
      .replace(/\s+/g, "_");
    const folderName = `ogrenci_belgeleri_${safeName}`;
    const folder = zip.folder(folderName);

    // 1) Application document
    try {
      const appResp = await api.get(`/unit/applications/${docsAppId}/document`, { responseType: "blob" });
      const appBuf = await appResp.data.arrayBuffer();
      folder.file("01_basvuru_belgesi.pdf", appBuf);
    } catch (e) {
      console.warn("Application PDF not available:", e);
    }

    // 2) Uploaded requirement documents
    for (const d of docsItems) {
      try {
        const r = await api.get(`/admin/applications/${docsAppId}/documents/${d.requirementId}`, { responseType: "blob" });
        const buf = await r.data.arrayBuffer();
        
        // ✅ FIX: Extract extension from original filename or content-type
        let ext = '.pdf'; // default fallback
        if (d.originalName) {
          const match = d.originalName.match(/\.[^.]+$/);
          if (match) ext = match[0];
        } else if (d.contentType) {
          const mimeMap = {
            'application/pdf': '.pdf',
            'application/msword': '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
            'image/jpeg': '.jpg',
            'image/png': '.png',
            'image/gif': '.gif'
          };
          ext = mimeMap[d.contentType] || '.pdf';
        }
        
        const base = (d.requirementName || d.requirementKey || `belge_${d.requirementId}`)
          .replace(/[^\p{L}\p{N}_\-. ]+/gu, "")
          .replace(/\s+/g, "_");
        const idx = String(d.requirementId).padStart(2, "0");
        folder.file(`${idx}_${base}${ext}`, buf); // ✅ Correct extension
      } catch (e) {
        console.warn(`Document ${d.requirementId} not available:`, e);
      }
    }

    const blob = await zip.generateAsync({ type: "blob" });
    window.saveAs(blob, `${folderName}.zip`);
  } catch (e) {
    console.error("ZIP download error:", e);
    alert("Belgeler ZIP olarak indirilemedi.");
  }
};


// Puantaj PDF export - Resmi belge formatı
const downloadPuantajCsv = async () => {
  try {
    const jspdfNS = await loadJsPdf();
    const { jsPDF } = jspdfNS;
    
    // A4 landscape (yatay)
    const doc = new jsPDF("landscape", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    

    
    doc.setFontSize(14);
    const subtitle = `${puSelectedUnitName || "BIRIM ADI"}`;
    doc.text(subtitle, pageWidth / 2, 22, { align: "center" });
    
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    const docTitle = "PUANTAJ LISTESI";
    doc.text(docTitle, pageWidth / 2, 30, { align: "center" });
    
    // Tarih bilgisi
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    const today = new Date().toLocaleDateString('tr-TR');
    doc.text(`Tarih: ${today}`, pageWidth / 2, 37, { align: "center" });
    
    // Ayraç çizgisi
    doc.setLineWidth(0.5);
    doc.setDrawColor(100, 100, 100);
    doc.line(20, 40, pageWidth - 20, 40);
    
    // Tablo başlıkları
    const head = [
      ["SIRA", "T.C. KIMLIK NO", "ADI SOYADI", "ZIRAAT BANKASI IBAN", "ÖDENECEK ÜCRET"]
    ];
    
    // Tablo içeriği - Türkçe karakterleri koruyarak
    const body = (puEmployees || []).map(e => [
      e.row || "",
      e.studentTcNo || "",
      (e.studentName || "").toUpperCase(), // Resmi belgeler için büyük harf
      e.ibanText || "",
      e.monthlyAmount + " TL" || "0.00 TL"
    ]);
    
    if (body.length === 0) {
      body.push([
        { 
          content: "Kayıt bulunamadı", 
          colSpan: 5, 
          styles: { 
            halign: "center", 
            fontStyle: "italic", 
            textColor: [150, 150, 150],
            fontSize: 10
          } 
        }
      ]);
    }
    
    if (!doc.autoTable) {
      alert("PDF tablo eklentisi yüklenemedi. Lütfen sayfayı yenileyin.");
      return;
    }
    
    // Tablo genişlik hesaplama
    const tableWidth = 18 + 40 + 70 + 75 + 35; // Toplam sütun genişlikleri
    const startX = (pageWidth - tableWidth) / 2; // Ortalama için başlangıç noktası
    
    // Tablo oluştur
    doc.autoTable({
      head,
      body,
      startY: 45,
      margin: { left: startX, right: startX },
      tableWidth: tableWidth,
      styles: { 
        fontSize: 9,
        cellPadding: 3,
        overflow: 'linebreak',
        cellWidth: 'wrap',
        font: 'helvetica',
        lineColor: [100, 100, 100],
        lineWidth: 0.3,
        valign: 'middle'
      },
      headStyles: { 
        fillColor: [70, 70, 70],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        halign: 'center',
        fontSize: 9,
        cellPadding: 4
      },
      bodyStyles: {
        textColor: [40, 40, 40],
        fontSize: 9
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      },
      columnStyles: { 
        0: { 
          cellWidth: 18,
          halign: 'center',
          fontStyle: 'bold'
        }, 
        1: { 
          cellWidth: 40,
          halign: 'center'
        }, 
        2: { 
          cellWidth: 70,
          halign: 'left'
        }, 
        3: { 
          cellWidth: 75,
          halign: 'left',
          fontSize: 8
        }, 
        4: { 
          cellWidth: 35,
          halign: 'right',
          fontStyle: 'bold'
        } 
      },
      theme: 'grid',
      didDrawPage: function (data) {
        // Alt bilgi - sayfa numarası ve tarih
        const pageCount = doc.internal.getNumberOfPages();
        
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(100, 100, 100);
        
        // Sol alt - tarih/saat
        const dateTime = new Date().toLocaleString('tr-TR');
        doc.text(`Oluşturulma: ${dateTime}`, 20, pageHeight - 10);
        
        // Sağ alt - sayfa numarası
        doc.text(
          `Sayfa ${data.pageNumber} / ${pageCount}`,
          pageWidth - 20,
          pageHeight - 10,
          { align: 'right' }
        );
        
        // Alt çizgi
        doc.setLineWidth(0.3);
        doc.setDrawColor(150, 150, 150);
        doc.line(20, pageHeight - 15, pageWidth - 20, pageHeight - 15);
      },
      didParseCell: function(data) {
        // Türkçe karakterleri korumak için encoding ayarı
        if (data.cell.text && data.cell.text.length > 0) {
          // jsPDF varsayılan olarak helvetica ile çoğu Türkçe karakteri destekler
          // Ekstra işlem gerekmez, sadece font'un doğru seçildiğinden emin oluyoruz
          data.cell.styles.font = 'helvetica';
        }
      }
    });
    
    // Son sayfaya imza bölümü ekle
    const finalY = doc.lastAutoTable.finalY || 45;
    
    if (finalY < pageHeight - 60) {
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(40, 40, 40);
      


    }
    
    // Dosya adını oluştur
    const safeName = (puSelectedUnitName || "birim")
      .toString()
      .replace(/ğ/g, 'g')
      .replace(/Ğ/g, 'G')
      .replace(/ü/g, 'u')
      .replace(/Ü/g, 'U')
      .replace(/ş/g, 's')
      .replace(/Ş/g, 'S')
      .replace(/ı/g, 'i')
      .replace(/İ/g, 'I')
      .replace(/ö/g, 'o')
      .replace(/Ö/g, 'O')
      .replace(/ç/g, 'c')
      .replace(/Ç/g, 'C')
      .replace(/[^a-zA-Z0-9]/g, '_');
    
    const fileName = `Puantaj_Listesi_${safeName}_${today.replace(/\./g, '_')}.pdf`;
    doc.save(fileName);
    
  } catch (e) {
    console.error("Puantaj PDF indirme hatası:", e);
    alert("PDF oluşturulamadı: " + (e.message || "Bilinmeyen hata"));
  }
};

// Kaydet butonuna basınca edit mode açılır ve draft state kopyalanır
// Kaydet/İptal ile edit mode kapanır ve draft sıfırlanır
const saveMonthlyUpdates = async () => {
  try {
    const hourlyWage = parseFloat(localStorage.getItem("announcementHourlyWage")) || 88.90;
    const updates = puMonthlyDraft.map(r => ({
      studentSicilNo: r.studentSicilNo,
      perDay: r.perDay
    }));

    const resp = await api.post(`/admin/puantaj/unit/${puSelectedUnit}/monthly-update`, {
      month: puMonthlyMonth,
      updates,
      hourlyWage
    });

    if (resp.data?.success) {
      alert("Değişiklikler kaydedildi!");
      setPuMonthlyEditing(false);
      setPuMonthlyDraft(null);
      await fetchPuMonthly(puMonthlyMonth); // tabloyu yeniden yükle
    } else {
      alert("Kaydetme başarısız oldu.");
    }
  } catch (err) {
    console.error(err);
    alert("Bir hata oluştu.");
  }
};



  // NEW: notification polling refs/state
  const [notifMetaVersion, setNotifMetaVersion] = useState(0);
  const notifPollTimerRef = useRef(null);
  const notifPollBackoffRef = useRef(10000); // start 10s

  // NEW: notification polling logic
  const scheduleNotifPoll = (delayMs) => {
    if (notifPollTimerRef.current) clearTimeout(notifPollTimerRef.current);
    notifPollTimerRef.current = setTimeout(doNotifPoll, delayMs);
  };

  const doNotifPoll = async () => {
    try {
      const admin = getAdminUser();
      if (!admin?.sicilNo) {
        scheduleNotifPoll(150000);
        return;
      }
      // meta-only poll for unread/version
      const resp = await api.get(`/admin/notifications/${admin.sicilNo}`, { params: { meta: 1 } });
      const meta = resp.data?.meta || {};
      const v = meta.version || 0;
      if (typeof meta.unreadCount === 'number') {
        setUnreadCount(meta.unreadCount); // update badge
      }
      if (v && v !== notifMetaVersion) {
        setNotifMetaVersion(v);
        // If modal open, refresh full list silently; otherwise only badge is enough
        if (notifOpen) {
          await fetchNotifications();
        }
      }
      notifPollBackoffRef.current = 1000000;
      scheduleNotifPoll(1000000);
    } catch {
      // backoff up to 60s
      const next = Math.min((notifPollBackoffRef.current || 10000) * 2, 600000);
      notifPollBackoffRef.current = next;
      scheduleNotifPoll(next);
    }
  };

  // NEW: start/stop notification polling on mount + visibility
  useEffect(() => {
    const onVis = () => { if (!document.hidden) doNotifPoll(); };
    document.addEventListener("visibilitychange", onVis);
    scheduleNotifPoll(800);
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      if (notifPollTimerRef.current) clearTimeout(notifPollTimerRef.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // NEW: get institutions with at least one active employee in child units
  const getActivePuantajInstitutions = () => {
    // puantajCounts: { [unitId]: count }
    // units: [{ _id, ustBirim: { _id }, ... }]
    // institutions: [{ _id, ustKurum }]
    const unitHasActive = new Set(
      units.filter(u => puantajCounts[u._id] > 0).map(u => u.ustBirim._id)
    );
    return institutions.filter(inst => unitHasActive.has(inst._id));
  };

  // Saatlik ücret state: default 88.90, localStorage'dan yükle
const [announcementHourlyWage, setAnnouncementHourlyWage] = useState(() => {
  const saved = localStorage.getItem("announcementHourlyWage");
  return saved !== null && saved !== "" ? saved : "88.90";
});

  // "Onayla" butonu için fonksiyon: veritabanından o birimin o ayki toplam saatlerini çekip, local saatlik ücret ile hesaplar
const handleMonthlyApprove = async () => {
  if (!puSelectedUnit || !puMonthlyMonth) return;
  let hourlyWage = 88.90;
  const wageStr = localStorage.getItem("announcementHourlyWage");
  if (wageStr && !isNaN(parseFloat(wageStr))) hourlyWage = parseFloat(wageStr);

  try {
    // Backend'den tutarları ve saatleri çek (tutarlar kalıcı)
    const resp = await api.get(`/unit/${puSelectedUnit}/monthly-timesheet`, {
      params: { month: puMonthlyMonth, hourlyWage }
    });
    if (!resp.data?.success || !resp.data.data?.rows) {
      alert("Aylık çalışma saatleri alınamadı.");
      return;
    }
    setPuMonthlyData(prev => ({
      ...prev,
      rows: resp.data.data.rows
    }));

    console.log("Aylık Liste Onaylanmıştır.");
  } catch (e) {
    alert("Aylık çalışma saatleri alınamadı.");
  }
};

  return (
    <div className="admin-page-wrapper">
      <header className="admin-header">
        <div className="header-content">
          <img src={kouLogo} alt="KOU Logo" className="header-logo" />
          <h1 className="header-title">
            Kısmi Zamanlı Öğrenci Süreç Takip Sistemi
          </h1>
          <HeaderActions /> {/* NEW */}
        </div>
      </header>

      <main className="admin-main">
        {/* Sekmeler */}
        <div className="tabs">
        <div className="tabs-left">
            <button
              className={`tab-btn ${activeTab === "birimler" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("birimler");
                setPuSelectedUnit(null);
                setPuSelectedUnitName("");
                setSelectedUnit(null); // CHANGED: clear selected unit
              }}
            >
              Birimler
            </button>
            <button
              className={`tab-btn ${activeTab === "puantaj" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("puantaj");
                setSelectedUnit(null); // CHANGED: clear selected unit
                setPuSelectedUnit(null);
                setPuSelectedUnitName("");
              }}
            >
              Puantaj
            </button>
            <button
              className={`tab-btn ${activeTab === "ilan" ? "active" : ""}`}
              onClick={() => {
                setActiveTab("ilan");
                setSelectedUnit(null); // CHANGED: clear selected unit
                setPuSelectedUnit(null);
                setPuSelectedUnitName("");
              }}
            >
              İlan Düzenleme
            </button>
          </div>

        </div>

        {/* İçerik */}
        <div className="admin-tab-content" ref={contentRef} key={activeTab}>

          {activeTab === "birimler" && renderBirimlerContent()}

          {activeTab === "puantaj" && (
            <>
              {puSelectedUnit ? (
                // Puantaj detail view
                <>
                  {puMonthlyOpen ? (
                    // NEW: Monthly puantaj table for the selected unit
                    <div className="pu-shell">
                      <button
                        className="pu-side-btn pu-back"
                        onClick={closePuMonthly}
                        title="Geri Dön"
                      >
                        <i className="fa-solid fa-chevron-left"></i>
                      </button>

                      <div className="pu-view" style={{ position: "relative" }}>
                        <div className="pu-title">
                          <UnitMonthlyTable
                            data={
                              puMonthlyEditing
                                ? puMonthlyData
                                  ? { ...puMonthlyData, rows: puMonthlyDraft, month: puMonthlyMonth }
                                  : null
                                : puMonthlyData
                                  ? { ...puMonthlyData, month: puMonthlyMonth }
                                  : null
                            }
                            loading={puMonthlyLoading}
                            onMonthChange={onChangePuMonthlyMonth}
                            editable={puMonthlyEditing}
                            onCellChange={(sicilNo, day, value) => {
                              setPuMonthlyDraft(prev => {
                                const updated = prev ? [...prev] : [];
                                const row = updated.find(r => r.studentSicilNo === sicilNo);
                                if (row) {
                                  row.perDay[String(day)] = value;
                                  row.totalHours = Object.values(row.perDay).reduce((a, b) => a + Number(b || 0), 0);
                                }
                                return updated;
                              });
                            }}
                          />


                        </div>
                        <div className="pu-monthly-side-btn-group">
                          {!puMonthlyEditing ? (
                            <button
                              className="pu-monthly-side-btn"
                              onClick={() => {
                                setPuMonthlyEditing(true);
                                setPuMonthlyDraft(puMonthlyData?.rows ? JSON.parse(JSON.stringify(puMonthlyData.rows)) : []);
                              }}
                              title="Güncelle"
                            >
                              <i className="fa-solid fa-pen"></i>
                            </button>
                          ) : (
                            <>
                              <button
                                className="pu-monthly-side-btn save"
                                onClick={saveMonthlyUpdates}
                                title="Kaydet"
                              >
                                <i className="fa-solid fa-check"></i>
                              </button>
                              <button
                                className="pu-monthly-side-btn cancel"
                                onClick={() => {
                                  setPuMonthlyEditing(false);
                                  setPuMonthlyDraft(null);
                                }}
                                title="İptal"
                              >
                                <i className="fa-solid fa-times"></i>
                              </button>
                            </>
                          )}
                          {!puMonthlyEditing ? (
                            <button
                              className="pu-monthly-side-btn"
                              onClick={async () => {
                                await handleMonthlyApprove();
                                closePuMonthly();
                                // Ana tabloyu güncelle
                                if (puSelectedUnit && puSelectedUnitName) {
                                  await openPuantajUnit(puSelectedUnit, puSelectedUnitName);
                                }
                              }}
                              title="Onayla"
                            >
                              <i className="fa-solid fa-check"></i>
                            </button>
                          ) : null}
                          {/* EKLENDİ: İndirme butonu */}
                          <button
                            className="pu-monthly-side-btn"
                            title="Excel İndir"
                             onClick={downloadMonthlyExcel}
                          >
                            <i className="fa-solid fa-download"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="pu-shell">
                      <button
                        className="pu-side-btn pu-back"
                        onClick={closePuantajUnit}
                        title="Geri Dön"
                      >
                        <i className="fa-solid fa-chevron-left"></i>
                      </button>

                      <div className="pu-view">
                        <div className="pu-card">
                          <div className="pu-title">{puSelectedUnitName || "Birim"}</div>
                          <div className="pu-table-wrap">
                            <table className="pu-table">
                              <thead>
                                <tr>
                                  <th>Sıra</th>
                                  <th>T.C. Kimlik No</th>
                                  <th>Ad - Soyad</th>
                                  <th>Ziraat Bankası İban</th>
                                  <th>Ödenecek Ücret</th>
                                  <th>Detay</th> {/* NEW */}
                                </tr>
                              </thead>
                              <tbody>
                                {puLoading ? (
                                  <tr><td colSpan={6} className="pu-muted">Yükleniyor...</td></tr>
                                ) : (
                                  <>
                                    {(() => {
                                      const MIN_ROWS = 10;
                                      const list = Array.isArray(puEmployees) ? puEmployees : [];
                                      const rows = [];

                                      if (list.length === 0) {
                                        // 1 info row + 9 placeholders
                                        rows.push({ __info: true, key: "pu-info-empty" });
                                        const placeholdersCount = Math.max(0, MIN_ROWS - 1);
                                        for (let i = 0; i < placeholdersCount; i++) {
                                          rows.push({ __empty: true, key: `pu-ph-${i}` });
                                        }
                                      } else {
                                        // existing employees +
                                        for (const e of list) rows.push(e);
                                        const placeholdersCount = Math.max(0, MIN_ROWS - list.length);
                                        for (let i = 0; i < placeholdersCount; i++) {
                                          rows.push({ __empty: true, key: `pu-ph-${i}` });
                                        }
                                      }

                                      return rows.map((e) => {
                                        if (e.__info) {
                                          return (
                                            <tr key={e.key}>
                                              <td colSpan={6} className="pu-muted">Kayıt bulunamadı</td>
                                            </tr>
                                          );
                                        }
                                        if (e.__empty) {
                                          return (
                                            <tr key={e.key} className="pu-row-empty">
                                              <td className="empty">&nbsp;</td>
                                              <td className="empty">&nbsp;</td>
                                              <td className="empty">&nbsp;</td>
                                              <td className="empty">&nbsp;</td>
                                              <td className="empty">&nbsp;</td>
                                              <td className="empty">&nbsp;</td> {/* NEW: placeholder for Detay */}
                                            </tr>
                                          );
                                        }
                                        return (
                                          <tr key={`${e.studentSicilNo}-${e.row}`}>
                                            <td>{e.row}</td>
                                            <td>{e.studentTcNo || ""}</td>
                                            <td>{e.studentName}</td>
                                            <td>{e.ibanText || ""}</td>
                                            <td>{e.monthlyAmount + " TL" || "0.00 TL"}</td>
                                        <td>
                        <button
                            className="pu-detail-btn"
                         onClick={() => showPuantajDetail(e)}
                       title="Detay"
                         type="button"
                              >
                          Detay
                          </button>
                                 </td>
                                          </tr>
                                        );
                                      });
                                    })()}
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <button
                        className="pu-side-btn pu-calendar"
                        title="Aylık Puantaj"
                        onClick={openPuMonthly}
                        disabled={!puMonthlyApproved} // NEW: onaylı değilse disable
                      >
                        <i className="fa-regular fa-calendar"></i>
                      </button>

                      <button
                        className="pu-side-btn pu-download"
                        onClick={downloadPuantajCsv}
                        title="PDF İndir"
                      >
                        <i className="fa-solid fa-download"></i>
                      </button>
                    </div>
                  )}
                </>
              ) : (
                // Puantaj unit list (click -> openPuantajUnit)
      <>
        {/* ✅ FIX: Empty state sadece aktif öğrenci yoksa göster */}
        {getActivePuantajInstitutions().length === 0 ? (
          <div className="admin-empty-state">
            <img src={adminHomeImg} alt="Boş içerik" className="admin-empty-img" />
            <p>
              Henüz sigortası başlamış öğrenci bulunmamaktadır.
              <br />
              Puantaj takibi yapabilmek için önce sigorta başlatın.
            </p>
          </div>
        ) : (
          <>
            {/* ✅ FIX: Search bar sadece aktif öğrenci varsa göster */}
            <div className="search-container">
              <div className="search-bar">
                <i className="fa-solid fa-magnifying-glass"></i>
                <input
                  type="text"
                  placeholder="Öğrenci Ara..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              <button
                className={`filter-btn2${puantajFilterActive ? " active" : ""}`}
                title="Sadece onaylanmış birimleri göster"
                onClick={() => setPuantajFilterActive(f => !f)}
              >
                <i className="fa-solid fa-filter"></i>
              </button>
            </div>

            {/* 📋 Search / Institutions */}
            {searchQuery.trim() === "" ? (
              // Filtreye göre üst kurum ve birim listesi
              <div className="institutions-list">
                {getFilteredPuantajInstitutions().map((institution) => {
                  const institutionUnits = getFilteredActiveUnitsByInstitution(institution._id);
                  const isExpanded = expandedPuantajInstitution === institution._id;

                  return (
                    <div key={institution._id} className="institution-item" id={`puantaj-${institution._id}`}>
                      <div
                        className="institution-header"
                        onClick={() => togglePuantajInstitution(institution._id)}
                      >
                        <div className="institution-info">
                          <h3 className="institution-name">{institution.ustKurum}</h3>
                        </div>
                        <div className="expand-icon">
                          <i className={`fa-solid ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                        </div>
                      </div>

                      {isExpanded && (
                        <div className="admin-units-dropdown">
                          {institutionUnits.length > 0 ? (
                            institutionUnits.map((unit) => (
                              <div key={unit._id} className="admin-unit-item">
                                <div
                                  className="admin-unit-info"
                                  onClick={() => openPuantajUnit(unit.sicilNo, unit.birimAdi)}
                                  role="button"
                                  title="Puantaj listesi"
                                >
                                  <div className="admin-unit-name-section">
                                    <span className="admin-unit-name">{unit.birimAdi}</span>
                                    <span className="admin-unit-sicil">Sicil: {unit.sicilNo}</span>
                                  </div>
                                  <div className="admin-unit-capacity">
                                    <span>Toplam Kontenjan: {unit.totalKapasite}</span>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="no-units">Bu üst kurumda aktif öğrenci yok.</div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              // Arama sonuçları
              <div className="institutions-list22">
                <PartTimeEmployeeSearchResults query={searchQuery} openPuantajUnit={openPuantajUnit} />
              </div>
            )}
          </>
        )}
      </>
    )}
  </>
)}

          {activeTab === "ilan" && (
            <div className="announcement-editor">
              <div className="announcement-form">
                <label className="ann-label">İlan Başlığı</label>
                <input
                  type="text"
                  className="ann-input"
                  value={announcement.title}
                  onChange={(e) =>
                    setAnnouncement((prev) => ({ ...prev, title: e.target.value }))
                  }
                  placeholder="İlan başlığını yazın"
                />
                {/* Dönem Bitiş Tarihi ve Saatlik Ücret yan yana, label üstte input altta */}
                <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginBottom: 12 }}>
                  <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    <label className="ann-label" style={{ marginBottom: 4 }}>Dönem Bitiş Tarihi</label>
                    <input
                      type="date"
                      className="ann-input"
                      value={announcementEndDate}
                      onChange={(e) => setAnnouncementEndDate(e.target.value)}
                      placeholder="YYYY-MM-DD"
                    />
                  </div>
                  <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                    <label className="ann-label" style={{ marginBottom: 4 }}>Saatlik Ücret</label>
                    <input
                      type="number"
                      className="ann-input"
                      value={announcementHourlyWage}
                      onChange={e => setAnnouncementHourlyWage(e.target.value)}
                      placeholder="Saatlik ücreti yazın"
                      min={0}
                      step="0.01"
                    />
                  </div>
                </div>
                <label className="ann-label">İlan İçeriği</label>
                <textarea
                  className="ann-textarea"
                  rows={12}
                  value={announcement.content}
                  onChange={(e) =>
                    setAnnouncement((prev) => ({ ...prev, content: e.target.value }))
                  }
                  placeholder="İlan metnini yazın. Her paragrafı yeni satıra yazın."
                />
                <div className="ann-actions">
                  <button className="ann-save" onClick={saveAnnouncement}>
                    Kaydet
                  </button>
                  <button className="ann-reset" onClick={resetAnnouncement}>
                    Varsayılana Dön
                  </button>
                  <button 
                    className={`ann-toggle ${isAnnouncementActive ? 'active' : 'inactive'}`}
                    onClick={toggleAnnouncementStatus}
                    title={isAnnouncementActive ? 'İlanı yayından kaldır' : 'İlanı yayınla'}
                  >
                    {isAnnouncementActive ? '🔴 Yayından Kaldır' : '🟢 Yayınla'}
                  </button>
                </div>
              </div>

              <div className="announcement-preview">
                <div className="announcement-card">
                  <h2 className="announcement-title">{announcement.title}</h2>
                  <div className="announcement-content">
                    {announcement.content
                      .split("\n")
                      .filter((p) => p.trim().length > 0)
                      .map((p, i) => (
                        <p key={i}>{p}</p>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </main>

      <AddUnitModal isOpen={isModalOpen} onClose={closeModal} />

      {/* NEW: Notifications Modal */}
      {notifOpen && (
        <div className="modal-overlay" onClick={closeNotifications}>
          <div className="student-info-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 680 }}>
            <div className="modal-header">
              <h3>Bildirimler</h3>
              <div style={{ marginLeft: "auto", display: "inline-flex", gap: 8 }}>
                <button className="confirm-btn" onClick={markAllRead} disabled={unreadCount === 0}>Tümünü Okundu İşaretle</button>
                <button className="modal-close-btn" onClick={closeNotifications}>×</button>
              </div>
            </div>
            <div className="modal-body" style={{ maxHeight: 520, overflowY: "auto", paddingTop: 8 }}>
              {notifLoading ? (
                <div style={{ padding: 12, color: "#666", fontSize: 14 }}>Yükleniyor...</div>
              ) : notifications.length === 0 ? (
                <div style={{ padding: 12, color: "#666", fontSize: 14 }}>Gösterilecek bildiriminiz yok.</div>
              ) : (
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {notifications.map(n => (
                    <li key={n._id} style={{
                      display: "grid", gridTemplateColumns: "1fr auto", gap: 8, padding: "10px 8px",
                      borderBottom: "1px solid #eee", background: n.goruldu ? "#fff" : "#f9fffb"
                    }}>
                      <div>
                        <div style={{ fontSize: 14, color: "#111827", fontWeight: n.goruldu ? 400 : 600 }}>{n.message}</div>
                        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>{timeAgo(n.saat || n.createdAt)}</div>
                      </div>
                      <div>
                        {!n.goruldu && (
                          <button className="cancel-btn" onClick={() => markOneRead(n._id)} style={{ padding: "6px 10px" }}>Okundu</button>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}

      {/* NEW: Reject Documents Modal */}
      {rejectModalOpen && (
        <div className="modal-overlay" onClick={closeRejectModal}>
          <div className="student-info-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 560 }}>
            <div className="modal-header">
              <h3>Belgeleri Reddet</h3>
              <button className="modal-close-btn" onClick={closeRejectModal}>×</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="rejectType">Red Tipi *</label>
                <select
                  id="rejectType"
                  value={rejectType}
                  onChange={(e) => setRejectType(e.target.value)}
                  className="form-control"
                  disabled={rejecting}
                >
                  <option value="resubmit">Belgeler Yanlış - Düzeltilmeli</option>
                  <option value="final">Direkt Red (Başvuru İptal)</option>
                </select>
                <div style={{ fontSize: 12, color: "#666", marginTop: 4 }}>
                  {rejectType === "resubmit" 
                    ? "Öğrenci belgelerini düzeltip yeniden yükleyebilir." 
                    : "Başvuru tamamen iptal edilir ve öğrenci tekrar başvuramaz."}
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="rejectReason">Red Sebebi *</label>
                <textarea
                  id="rejectReason"
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  placeholder="Red sebebini açıklayınız..."
                  className="form-control"
                  rows="4"
                  disabled={rejecting}
                  style={{ resize: "vertical", minHeight: 80 }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="cancel-btn" onClick={closeRejectModal} disabled={rejecting}>
                İptal
              </button>
              <button className="confirm-btn" onClick={confirmReject} disabled={rejecting}>
                {rejecting ? "İşleniyor..." : "Reddet"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* NEW: Puantaj - Employee Detail Modal */}
      {puDetailOpen && (
        <div className="modal-overlay" onClick={() => setPuDetailOpen(false)}>
          <EmployeeDetailCard
            detail={puDetailData}
            loading={puDetailLoading}
            onClose={() => setPuDetailOpen(false)}
            onTerminate={terminateEmployee}
            terminating={puTerminating}
          />
        </div>
      )}
    </div>
  );
}

export default AdminHomePage;
